export default __webpack_public_path__ + "static/media/BGImg.e9c58ee7.png";